<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="modal-content m-0">
    <div class="modal-header">
      <p class="modal-title">
        {{
          (id ? 'serviceData.form.editTitle' : 'serviceData.form.createTitle')
            | translate
        }}
      </p>
      <i
        class="fa-light fa-xmark ms-auto cursor-pointer"
        data-cy="sd-form-close-icon"
        (click)="modalRef.close()"
      ></i>
    </div>
    <div class="modal-body">
      @if (isStaging) {
        <button
          class="btn btn-success-vibrant btn-sm text-light my-2"
          type="button"
          [disabled]="prefillDisabled()"
          (click)="prefillTestData()"
        >
          {{ 'serviceData.form.prefillData' | translate }}
        </button>
      }
      @if (canViewPatientInformationSection$ | async) {
        <section data-cy="PatientInformation-section">
          <p class="caption mb-1">
            {{ 'serviceData.form.patientInformation' | translate }}
          </p>
          <hr class="mt-0" />
          <ng-container formGroupName="patientInformation">
            <app-service-data-form-patient-information [id]="id" />
          </ng-container>
        </section>
      }
      <section data-cy="ServiceInformation-section">
        <p class="caption mb-1">
          {{ 'serviceData.form.serviceInformation' | translate }}
        </p>
        <hr class="mt-0" />
        <app-service-data-form-service-information [id]="id" />
        <app-service-data-form-bundle-information
          [fieldSet]="fieldSet"
          [id]="id"
        />
      </section>
      <ng-container formGroupName="serviceInformation">
        <app-service-data-form-additional-patient-information
          [fieldSet]="fieldSet"
          [id]="id"
        />
        <app-service-data-form-additional-participants
          [fieldSet]="fieldSet"
          [id]="id"
        />
        <app-service-data-form-current-pregnancy-information
          [fieldSet]="fieldSet"
          [id]="id"
        />
        <app-service-data-patient-history-information
          [fieldSet]="fieldSet"
          [id]="id"
        />
      </ng-container>
      <section
        formGroupName="paymentInformation"
        data-cy="PaymentInformation-section"
      >
        <p class="caption mb-1">
          {{ 'serviceData.form.paymentInformation' | translate }}
        </p>
        <hr class="mt-0" />
        <app-service-data-form-payment-information [id]="id" />
      </section>
      <section data-cy="OtherInformation-section">
        <p class="caption mb-1">
          {{ 'serviceData.form.otherInformation' | translate }}
        </p>
        <hr class="mt-0" />
        <app-service-data-form-other-information [id]="id" />
      </section>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-primary"
        data-cy="sd-form-create-btn"
        [disabled]="loading"
        [class.loading]="loading"
      >
        {{
          (id ? 'common.buttons.btnUpdate' : 'common.buttons.btnCreate')
            | translate
        }}
      </button>
    </div>
  </div>
</form>
